<script setup lang="ts">
import { computed } from 'vue'
import { formatToInternational } from '@shared/utils'
import Box from '@uiKit/elements/Box.vue'
import { formatBand } from '../../trading'
import SellOutcomeHero from './SellOutcomeHero.vue'
import SellSummaryCard, { type SellSummaryRow } from './SellSummaryCard.vue'
import SellNote from './SellNote.vue'
import { REJECTED_NOTE, rejectedSubtitle } from '../constants/sellCopy'
import { formatAmount } from '../utils/sellListingUtils'

// Sell 9 — Listing Rejected (Figma 34433:273439): the valuation check failed,
// the tokens are unlocked, and the band to relist within.

interface Props {
  reason: string
  tokens: number
  valuation: number
  bandMin: number
  bandMax: number
}

const props = defineProps<Props>()

const rows = computed<SellSummaryRow[]>(() => [
  { label: 'Latest DLD valuation', value: formatAmount(props.valuation) },
  { label: 'Permitted band', value: formatBand(props.bandMin, props.bandMax) },
  { label: 'Tokens unlocked', value: formatToInternational(props.tokens), tone: 'success' },
])
</script>

<template>
  <Box direction="col" justify="center" gap="14px" grow>
    <SellOutcomeHero
      icon="exclamation-circle"
      tone="danger"
      title="Listing could not be approved"
      :subtitle="rejectedSubtitle(tokens)"
    />
    <SellNote tone="danger" icon="exclamation-circle" title="Reason" :text="reason" />
    <SellSummaryCard eyebrow="WHAT YOU CAN DO" :rows="rows" />
    <SellNote :text="REJECTED_NOTE" />
  </Box>
</template>
